<template>
  <div class="grapher">
    <div class="search-form">
      <a-space>
        <div>
          <a-button @click="doUpload" block icon="cloud-upload" type="primary">上传图片</a-button>
          <UploadDrawer :album="album" :member="member" @close="refresh" ref="uploadDrawer"/>
          <a-popover placement="bottomLeft">
            <template slot="content">
              <ShortcutDesc/>
            </template>
            <a-button
                icon="question-circle" size="small" shape="round" type="dashed" block
                style="margin-top: 14px;">操作说明
            </a-button>
          </a-popover>
        </div>
        <div>
          <SearchForm :query-params="params" @click="search"/>
          <div style="margin:14px 0 0 10px;">
            <ActionBar :album="member.album" :query-params="params" :selected="selected"
                       @refresh="refresh" @search="search"/>
            <span v-if="no_origin" style="color: red;"><a-icon type="sound"/> 注意：您还有{{ no_origin }}张原图未上传</span>
          </div>
        </div>
      </a-space>
    </div>
    <PhotoList ref="photoList" :load-func="loadFunc" :album="member.album"
               :query-params="params" :decr-width="25" v-model="selected"/>
  </div>
</template>

<script>
import api from "../../../../utils/api";
import func from "../../../../utils/func";
import PhotoList from "./comps/PhotoList";
import ActionBar from "./grapher/ActionBar";
import UploadDrawer from "./comps/UploadDrawer";
import ShortcutDesc from "./comps/ShortcutDesc";
import SearchForm from "./grapher/SearchForm";

export default {
  name: "Grapher",
  props: ["album", "member"],
  components: {SearchForm, ShortcutDesc, UploadDrawer, ActionBar, PhotoList},
  data() {
    return {
      params: {
        raw: 0, top: 0, star: 0, origin: 0,
        time_type: 1, start: 0, finish: 0,
        file_name: "", bib_num: "", order_by: 1,
      },
      selected: [],
      no_origin: 0,
      loadFunc: api.v1.album.photo.myself,
    }
  },
  methods: {
    search() {
      this.$refs.photoList.search();
    },
    async refresh(clean) {
      await this.$refs.photoList.refresh();
      if (func.boolStrict(clean)) {
        this.$refs.photoList.clean(true);
      }
      let res = await api.v1.album.stats.member(this.album.id, this.member.id);
      let stats = func.isDefined(res[this.member.id]) ? res[this.member.id] : {photo_release: 0, photo_origin: 0};
      this.no_origin = stats["photo_release"] - stats["photo_origin"];
    },
    doUpload() {
      this.$refs.uploadDrawer.open();
    }
  }
}
</script>

<style scoped lang="less">
.grapher {
  .search-form {
    width: 100%;
    padding: 15px 16px;
    background: #fff;
    z-index: 800;
    position: relative;
    box-shadow: 0 0 5px 5px #dedede;

    .left {
      float: left;
      width: 204px;
      margin-right: 16px;
      padding-right: 16px;
      border-right: 1px #eee solid;
    }
  }
}
</style>
